import { Row, Select, Space } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
const { Option } = Select;

import mediaSettingsSelector from '@Redux/mediaSettings/mediaSettingsSelector';

import DragUpload from '@Components/BasicComponents/DragUpload';
import BasicLabel from '@Components/BasicComponents/BasicLabel';
import InfoTooltip from './InfoTooltip';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export default function MultiLanguageDragUpload({handleUpload, onRemove, value, countryCode, setCountryCode, ...props}) {
  const {languages} = useSelector(mediaSettingsSelector);

  const fileList = useMemo(() => value[countryCode] ? [{uid: 0, ...value[countryCode]}] : [ ], [value[countryCode]]);

	return (
    <>
      <Row justify="space-between" align="middle">
        <BasicLabel
          title="Attachment"
          tooltip="An additional file uploaded alongside the media content, such as documentation or supporting materials."
        />
        <Space>
          <InfoTooltip
            text="To indicate and define the language in which the media content is presented. English is mandatory for the required fields."
            style={{marginRight: 20}}
          />
          <Select
            value={countryCode}
            style={{ width: 150 }}
            onChange={setCountryCode}
            loading={languages.loading}
          >
            {
              languages.data?.map(({id, nameIso}) =>
                <Option key={id} value={id}>
                  <Space>
                    {nameIso}
                    {value[id]  && <CheckOutlined />}
                  </Space>
                </Option>)
            } 
          </Select>
        </Space>
      </Row>
			<br/>
				<DragUpload
					listType="picture"
					value={fileList}
					handleUpload={(file) => handleUpload({...file, countryCode})}
					onRemove={onRemove}
          {...props}
				/>
      </>
	);
}